<nb-card class="lista-crud">
  <nb-card-header class="head">
    <div class="titulo-bloco">
      <span class="titulo-principal">Turmas</span>
    </div>
    <button nbButton status="primary" size="medium" class="btn-primario-crud" (click)="abrirDialog()">
      <nb-icon pack="eva" icon="book-outline" class="icone-primario-crud"></nb-icon>
      <span>Adicionar turma</span>
    </button>
  </nb-card-header>

  <nb-card-body>
    <div class="smart-toolbar">
      <div class="filtro-toolbar-inline">
        <div class="filtro-turma-full">
          <label class="field-label" for="turmaFiltroNome">Pesquisa</label>
          <nb-form-field>
            <nb-icon nbPrefix pack="eva" icon="search-outline"></nb-icon>
            <input
              nbInput
              fullWidth
              id="turmaFiltroNome"
              placeholder="Nome ou ano — Enter para buscar"
              name="turmaFiltro"
              [(ngModel)]="filtro"
              (keyup.enter)="buscarAgora()"
            />
          </nb-form-field>
        </div>
        <div class="campo-filtro--acoes">
          <button nbButton status="basic" size="small" type="button" (click)="buscarAgora()" title="Buscar agora" aria-label="Buscar agora">
            <nb-icon pack="eva" icon="search-outline"></nb-icon>
          </button>
        </div>
      </div>
    </div>

    <app-barra-carregando *ngIf="carregando"></app-barra-carregando>
    <div class="smart-table-wrap" *ngIf="turmas.length">
      <table class="smart-table">
        <thead>
          <tr>
            <th appOrdenavel campo="nome" rotuloAcessivel="Nome" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Nome</th>
            <th appOrdenavel campo="diaSemana" rotuloAcessivel="Dia da semana" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Dia da semana</th>
            <th appOrdenavel campo="horarioInicio" rotuloAcessivel="Horário de início" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Horário de início</th>
            <th appOrdenavel campo="horarioFim" rotuloAcessivel="Horário de fim" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Horário de fim</th>
            <th appOrdenavel campo="ano" rotuloAcessivel="Ano" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Ano</th>
            <th class="col-num">Matriculados</th>
            <th class="col-acoes col-acoes--menu">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let turma of turmas; let i = index">
            <td data-label="Nome">{{ turma.nome }}</td>
            <td data-label="Dia da semana">{{ turma.diaSemana }}</td>
            <td data-label="Horário de início">{{ formatarHoraHm(turma.horarioInicio) || '—' }}</td>
            <td data-label="Horário de fim">{{ formatarHoraHm(turma.horarioFim) || '—' }}</td>
            <td data-label="Ano">{{ turma.ano }}</td>
            <td class="col-num" data-label="Matriculados">{{ turma.quantidadeMatriculas ?? 0 }}</td>
            <td class="col-acoes col-acoes--menu" data-label="Ações">
              <button
                type="button"
                nbButton
                size="small"
                appearance="ghost"
                status="basic"
                class="btn-acoes-turma-menu"
                [nbContextMenu]="acoesContextMenu(turma, i)"
                nbContextMenuTrigger="click"
                [nbContextMenuPlacement]="menuPlacementBottomEnd"
                nbContextMenuClass="turma-acoes-context-menu"
                [nbContextMenuTag]="contextMenuTag"
                [attr.aria-label]="'Ações: ' + turma.nome"
                aria-haspopup="true"
              >
                <span class="btn-acoes-turma-menu__inner">
                  <span class="acoes-turma-icone-bubble" aria-hidden="true">
                    <nb-icon pack="eva" icon="grid-outline" class="acoes-turma-icone"></nb-icon>
                  </span>
                  <span class="acoes-turma-texto">Ações</span>
                </span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-lista-vazia
      *ngIf="!turmas.length"
      icone="book-open-outline"
      [filtrado]="temFiltro"
      mensagem="Nenhuma turma cadastrada ainda."
      mensagemFiltrado="Nenhuma turma casa com o recorte atual."
      acaoCriarRotulo="Cadastrar turma"
      (criar)="abrirDialog()"
      (verTodos)="limparFiltro()"
    ></app-lista-vazia>

    <div class="lista-paginacao" *ngIf="totalPages > 0">
      <button nbButton size="small" [disabled]="page === 1" (click)="onPageChange(page - 1)">Anterior</button>
      <span>Página {{ page }} de {{ totalPages }}</span>
      <button nbButton size="small" [disabled]="page === totalPages" (click)="onPageChange(page + 1)">Próxima</button>
    </div>
  </nb-card-body>
</nb-card>
